import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <Section data-id="element-103" data-mp="1clzc0idd4o2w">
      <Eyebrow data-id="element-104" data-mp="1clpod1fsit0d">And you’ll get these 5 exclusive bonuses free</Eyebrow>
      <Heading data-id="element-105" data-mp="18kduuktspnmw">5 Exclusive bonus tools</Heading>
      <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-zinc-400" data-id="element-106" data-mp="18hhwwwhy6yyg">
        Five additional tools designed to help you turn better welding decisions into better
        workshop results.
      </p>

      <ul className="mt-9 space-y-6" data-id="element-107" data-mp="1w8x1kvx75scv">
        {bonuses.map(b => <li key={b.number} className="overflow-hidden rounded-2xl border border-ink-600 bg-ink-800" data-id="element-108" data-mp="1wb9olnhtasws">
            <img src={b.image} alt={`${b.title} digital bonus package mockup`} className="block w-full bg-white" width={1240} height={1240} loading="lazy" data-id="element-109" data-mp="1rcexly9oxy1l" />
            <div className="p-5" data-id="element-110" data-mp="1eupym63z0vxy">
              <div className="flex flex-wrap items-center gap-2" data-id="element-111" data-mp="1erkaat361y3a">
                <span className="rounded-md bg-flame-500 px-2.5 py-1 font-display text-sm font-extrabold uppercase tracking-wide text-ink-900" data-id="element-112" data-mp="1jrghf175u5n2">
                  {b.number}
                </span>
                {b.tag ? <span className="rounded-md border border-spark/60 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-spark" data-id="element-113" data-mp="1aq8luqw13iwo">
                    {b.tag}
                  </span> : null}
                <span className="ml-auto text-sm font-bold uppercase text-zinc-400" data-id="element-114" data-mp="n2h77gn0mts8">
                  Value: <s className="text-zinc-500" data-id="element-115" data-mp="n0o0608hq7jp">{b.value}</s>{' '}
                  <span className="text-flame-400" data-id="element-116" data-mp="r4lyi8pzrebp">FREE</span>
                </span>
              </div>

              <h3 className="mt-4 font-display text-2xl font-extrabold uppercase leading-tight tracking-wide text-white sm:text-3xl" data-id="element-117" data-mp="d4tail5unc7f">
                {b.title}
              </h3>
              <p className="mt-1.5 font-display text-base font-bold uppercase tracking-wide text-spark" data-id="element-118" data-mp="2jtlijk06zsfy">
                {b.kicker}
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-zinc-300" data-id="element-119" data-mp="2f00i7lb4mmdl">{b.body}</p>

              {b.bullets ? <ul className="mt-4 space-y-2" data-id="element-120" data-mp="261f4q4kihxjo">
                  {b.bullets.map(item => <li key={item} className="flex gap-2.5" data-id="element-121" data-mp="32r5whw1f56ls">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame-400" aria-hidden="true" data-id="element-122" data-mp="32qmphadb42mj" />
                      <span className="text-[14px] leading-snug text-zinc-200" data-id="element-123" data-mp="2ynq2z8knbmdb">{item}</span>
                    </li>)}
                </ul> : null}

              {b.footer ? <p className="mt-4 border-t border-ink-600 pt-3 text-[13px] leading-snug text-zinc-400" data-id="element-124" data-mp="2ou0uq88qmtwc">
                  {b.footer}
                </p> : null}
            </div>
          </li>)}
      </ul>

      <p className="mt-9 text-center font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-125" data-mp="1392uwe8ul2ms">
        Claim the 6 Master Volumes + all 5 bonuses today
      </p>
      <div className="mt-4" data-id="element-126" data-mp="1d70jj2umd1fx">
        <CTAButton data-id="element-127" data-mp="1d5pez0tcnpnr" />
      </div>
    </Section>;
}